/**
 * Created by tofael on 11/7/17.
 */
import React from 'react';
import AdminForm from '../shared/admin-form';
import globalStyles from '../../utility/styles';

const style = {
  box: {
    marginLeft: '20%',
    marginRight: '20%'
  }
};


const AdminCreationPage = (props) => {
  return (
    <div>
      <h1 style={globalStyles.header}>Create Admin</h1>
      <div style={style.box}>
        <AdminForm {...props}/>
      </div>
    </div>
  )
}

export default AdminCreationPage;


// WEBPACK FOOTER //
// ./src/screens/create-admin/index.js